import {
  Box,
  Container,
  Wrap,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main/MainLayout';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import NetworkPhysicalCharacteristicsRoads from './components/report-sections/NetworkPhysicalCharacteristicsRoads';
import NetworkPhysicalCharacteristicsCycleways from './components/report-sections/NetworkPhysicalCharacteristicsCycleways';
import NetworkPhysicalCharacteristicsBridges from './components/report-sections/NetworkPhysicalCharacteristicsBridges';
import NetworkPhysicalCharacteristicsReportHeader from './components/report-headers/NetworkPhysicalCharacteristicsReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';
import NetworkPhysicalCharacteristicsAverageLife from './components/report-sections/NetworkPhysicalCharacteristicsAverageLife';

function NetworkPhysicalCharacteristics() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Network Physical Characteristics"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <Text mb={4}>This page provides information on core characteristics of the network: the length of the road and cycleway networks; the ratio of urban roads to rural roads; the number of bridges in the network, and the average life of road rehabilitation and resurfacing over time.</Text>
          )}
        />
        <Box ref={printableRef}>
          <NetworkPhysicalCharacteristicsReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <NetworkPhysicalCharacteristicsRoads />
            <NetworkPhysicalCharacteristicsCycleways />
            <NetworkPhysicalCharacteristicsBridges />
            <NetworkPhysicalCharacteristicsAverageLife />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default NetworkPhysicalCharacteristics;
